<h2 mat-dialog-title>{{ isEditing ? 'Edit note' : 'Create note' }}</h2>

<mat-dialog-content class="mat-typography" [formGroup]="form">
  <div class="create-note">
    <div class="field">
      <label class="form-label"> Title <span class="required">*</span></label>
      <mat-form-field [class.error]="form.get('title')?.invalid && form.get('title')?.touched">
        <input matInput formControlName="title" placeholder="Title" />
        @if (form.get('title')?.hasError('required') && form.get('title')?.touched) {
          <mat-error>Title is required</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="field description-field">
      <label class="form-label"> Description <span class="required">*</span></label>
      <div [class.editor-error]="form.get('text')?.invalid && form.get('text')?.touched">
        <angular-editor formControlName="text" [config]="configEN" />
      </div>
      @if (form.get('text')?.hasError('required') && form.get('text')?.touched) {
        <div class="error-message">Description is required</div>
      }
    </div>

    <!-- existing files -->
    @for (item of attachments; track $index) {
      <app-file-upload 
        class="files" 
        label="" 
        [fileName]="item.fileName!" 
        (delete)="deleteFile(item.id!)"
        (changed)="getFile($event, $index)" 
      />
    }

    <!-- new files -->
    @for (item of files; track $index) {
      <app-file-upload 
        class="files" 
        label="" 
        [fileName]="item.fileName!" 
        (delete)="removeFileFromList($index)"
        (changed)="getFile($event, $index)" 
      />
    }
    <!-- (download)="download()" -->


    @if (showAddFileBtn) {
      <button mat-button class="btn-add-file" matTooltip="New" (click)="addFile()">
        <mat-icon svgIcon="plus" />
        Add file
      </button>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button mat-stroked-button (click)="save()" [disabled]="form.invalid">
    {{ isEditing ? 'Save' : 'Create' }}
  </button>
</mat-dialog-actions>
